module.exports = __webpack_public_path__ + "img/abacuspic.2c07051c.png";